import {
  Route,
  Routes,
  useRoutes,
  Navigate,
  useNavigate,
} from 'react-router-dom';
//import Themeroutes from './routes/Router'
import { lazy, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Login from './views/LoginForm/Login.jsx';
import AddUserMaster from './views/UserMaster/AddUserMaster.jsx';
import UserMaster from './views/UserMaster/UserMaster.jsx';
import UserProfileMaster from './views/UserProfileMaster/UserProfileMaster.jsx';
import AddUserProfileMaster from './views/UserProfileMaster/AddUserProfileMaster.jsx';
import VenderMaster from './views/VendorMaster/VenderMaster.jsx';
import AddVenderMaster from './views/VendorMaster/AddVenderMaster.jsx';
import BranchMaster from './views/BranchMaster/BranchMaster.jsx';
import AddBranchMaster from './views/BranchMaster/AddBranchMaster.jsx';
import AddAdmissionNew from './views/AdmissionMaster/AddAdmissionNew.jsx';
import AddSlabMasterOld from './views/SlabMaster/AddSlabMasterOld.jsx';
import FeeDefaulterReport from './views/Report/FeeDefaulterReport.jsx';
import SessionSelection from './views/LoginForm/SessionSelection.jsx';
import PromoteAllStudents from './views/Tools/PromoteAllStudents.jsx';
import PromoteStudentsFeeSlabs from './views/Tools/PromoteStudentsFeeSlabs.jsx';
import CreateNewSessionSlab from './views/Tools/CreateNewSessionSlab.jsx';
import ItemDeletePage from './views/Item/ItemDeletePage.jsx';
import ItemCategory from './views/ItemCategory/ItemCategory.jsx';
import AddItemCategory from './views/ItemCategory/AddItemCategory.jsx';
import EditItemCategory from './views/ItemCategory/EditItemCategory.jsx';
import ToastNotifications from './layouts/ToastNotifications.js';

import { apiService } from './constants/ApiService.js';
import { toast } from 'react-toastify';

import PDFGeneratorButton from './views/Invoice/createPdf.js';
import CreatePdf_Formate2 from './views/Invoice/createPdf_Formate2.js';
import CreatePdf_Formate3 from './views/Invoice/createPdf_Formate3.js';
import CreatePdf_Formate4 from './views/Invoice/createPdf_Formate4.js';
import CreatePdf_Formate5 from './views/Invoice/createPdf_Formate5.js';
import CreatePdf_Formate6 from './views/Invoice/CreatePdf_Formate6.js';
import CreatePdf_Formate5_Landscape from './views/Invoice/createPdf_Formate5_Landscape.js';
import IDCardPDF from './views/AdmissionMaster/IDCardPDF.jsx';
import ICardBatches from './views/ICardMaster/ICardBatches.jsx';
import SaveICardBatches from './views/ICardMaster/SaveICardBatches.jsx';
import StudentList from './views/StudentList/StudentList.jsx';
import TcIssueSaveScreen from './views/TcIssueMasterDetail/TcIssueSaveScreen.jsx';
import StudentAcSearch from './views/StudentList/StudentAcSearch.jsx';
import StudentAc from './views/StudentList/StudentAc.jsx';
import AddLead from './views/LeadMaster/AddLead.js';
import GetLeadMaster from './views/LeadMaster/Getleadmaster.js';
import Leadhistory from './views/LeadMaster/Leadhistory.js';
import AddFacultyMaster from './views/FacultyMaster/AddFacultyMaster.jsx';
import FacultyMaster from './views/FacultyMaster/FacultyMaster.jsx';
import EnrollmentForm from './views/EnrollmentMaster/EnrollmentForm.jsx';
import EnrollmentList from './views/EnrollmentMaster/EnrollmentList.jsx';
import CourseContentPage from './views/Class_Master/CourseContentPage';
import AttendanceMasterPage from './views/AttendanceMaster/AttendanceMasterPage';
import AttendanceStudentListPage from './views/AttendanceMaster/AttendanceStudentListPage';
import GetStudentAttendanceReport from './views/AttendanceMaster/StudentAttendanceReport';

import GetTeachingMaster from './views/TeachingMaster/Teaching_Master_Search';
import AddTeachingMaster from './views/TeachingMaster/Teaching_Master_Add_Edit_Screen';
import BatchMaster from './views/BatchMaster/AddEditBatch';
import GetBatchList from './views/BatchMaster/BatchList';
import BatchCardList from './views/BatchMaster/BatchCardList';

import SaveEditWeekend from './views/WeekendMaster/AddEditWeekend';
import GetWeekendList from './views/WeekendMaster/WeekendList';
import SaveEditHoliday from './views/HolidayMaster/AddEditHoliday';
import GetHolidayList from './views/HolidayMaster/HolidayList';

import LeadsPendingForEnrollment from './views/LeadMaster/LeadsPendingForEnrollment.js';
import NotificationTest from './components/NotificationTest .js';
import WorkflowHelpPage from './constants/WorkflowHelpPage.js';

import SaveEditExamTerm from './views/ExamMaster/AddEditExamTerm';
import GetExamTermList from './views/ExamMaster/ExamTermList';

import SaveEditCourseExamPattern from './views/CourseExamMaster/AddEditCourseExamPattern';
import GetCourseExamPatternList from './views/CourseExamMaster/CourseExamPatternList';
import SaveCourseSubExamPattern from './views/CourseExamSubPattern/AddEditCourseExamSubPattern.js';
import GetCourseSubExamPatternList from './views/CourseExamSubPattern/CourseExamSubPatternList.js';
import SaveCreateSchoolCatalog from './views/CatalogMaster/CreateSchoolCatalog';
import GetCatalogList from './views/CatalogMaster/CatalogList';
import GetCatalogRenderer from './views/CatalogMaster/CatalogRenderer';
import SaveAutoAssign from './views/AutoAssignLead/AddEditLeadAutoAssignUser.js';
import GetAutoAssignList from './views/AutoAssignLead/LeadAutoAssignUserList.js';
import SaveSourceMapping from './views/LeadSourceMapping/AddEditLeadSourceMapping';
import GetSourceMappingList from './views/LeadSourceMapping/LeadSourceMappingList';
import { registerFCMToken } from './views/Firebase/fcmService.jsx';
import SaveFineMaster from './views/FineMaster/AddEditFineMaster.js';
import GetFineMasterList from './views/FineMaster/FineMasterList.js';
import SaveBatchExamMaster from './views/BatchExamMaster/AddEditBatchExamMaster.js';
import GetBatchExamList from './views/BatchExamMaster/BatchExamMasterList.js';
import SaveSessionMaster from './views/SessionMaster/AddEditSession.js';
import GetSessionList from './views/SessionMaster/SessionList.js';
import SaveExcelExportTblConfig from './views/ExcelExportTblConfig/SaveExcelExportTblConfig.js';
import GetExcelExportTblConfig from './views/ExcelExportTblConfig/GetExcelExportTblConfig.js';
import CommonImportExport from './views/ExcelDataImportExport/CommonImportExport.js';
import SaveHostelMaster from './views/HostelMaster/AddEditHostel.js';
import GetHostelMaster from './views/HostelMaster/HostelList.js';
import StudentHostelAssign from './views/HostelMapping/StudentHostelAssign.js';
import StudentHostelAssignList from './views/HostelMapping/StudentHostelAssignList.js';
import SaveStudentExamResult from './views/StudentExamResultSummary/AddEditStudentExamResult.js';
import GetStudentExamResultList from './views/StudentExamResultSummary/StudentExamResultList.js';
import SaveStudentExamResultEntry from './views/StudentExamResultSummary/StudentExamResultEntry.js';
import CourseContent from './views/StudentPortal/CourseContent.jsx';
import ExamDateSheet from './views/StudentPortal/ExamDateSheet.jsx';
import MyResults from './views/StudentPortal/MyResults.jsx';
import GetNotification from './views/NotificationFirebase/NotificationList.js';
import SaveNotification from './views/NotificationFirebase/AddEditNotification.js';
import GetChatBotPage from './views/chatbot/ChatBotPage.js';
import Fee_Reciept_HeadWise_Report from './views/FeeReciept/Fee_Reciept_HeadWise_Report.jsx';
import { listenForMessages } from './views/Firebase/firebaseListener.js';
import GetFacultydashboard from './views/Dashboard/Facultydashboard.js';
import GetStudentdashboard from './views/Dashboard/Studentdashboard.js';
import GetAccountantdashboard from './views/Dashboard/Accountantdashboard.js';
import GetCrmdashboard from './views/Dashboard/Crmdashboard.js';
import AddEditClassRoutine from './views/TimeTableMaster/AddEditTimeTable.js';
import ClassRoutineList from './views/TimeTableMaster/TimeTableList.js';
import GetTimeTableBoard from './views/TimeTableMaster/TimeTableBoard.js';
import GetFacultyTimeTableBoard from './views/TimeTableMaster/TeacherTimeTableBoard.js';
import GetStudentPaymentList from './views/StudentPayment/StudentPaymentList.js';
import SaveStudentPayment from './views/StudentPayment/Add_Edit_StudentPayment.js';
import ViewStudentPayment from './views/StudentPayment/StudentPaymentView.js';
import SaveEmployeAttandance from './views/EmployeAttandanceMaster/EmployeeAttendancePage.js';
import GetEmployeAttandance from './views/EmployeAttandanceMaster/EmployeeAttendanceListPage.js';
import GetEmpAttenReportPage from './views/EmployeAttandanceMaster/EmployeeAttendanceReportPage.js';
//new 24/042026
import AddPartyPartyCategoryMaster from './views/PartyCategory/AddPartyCategoryMaster.jsx';
import PartyCategoryMaster from './views/PartyCategory/PartyCategoryMaster.jsx';
import AddCityMaster from './views/CityMaster/AddCityMaster.jsx';
import CityMaster from './views/CityMaster/CityMaster.jsx';
import ChallanMaster from './views/Challan/ChallanMaster.jsx';
import AddChallanMaster from './views/Challan/AddChallanMaster.jsx';
import Aggrement from './views/Aggrement/Aggrement.jsx';
import SystemRecordsMaster from './views/SystemRecordsMaster/SystemRecordsMaster.jsx';
import AddSystemRecordsMaster from './views/SystemRecordsMaster/AddSystemRecordsMaster.jsx';
import AddHelperMaster from './views/Helper/AddHelperMaster.jsx';
import HelperMaster from './views/Helper/HelperMaster.jsx';
import HelperFlagMaster from './views/HelperFlag/HelperFlagMaster.jsx';
import AddHelperFlagMaster from './views/HelperFlag/AddHelperFlagMaster.jsx';
import ReceiptedMaster from './views/ReceiveChallan/ReceiveChallanMaster.jsx';
import AddReceiptedMaster from './views/ReceiveChallan/AddReceiveChallanMaster.jsx';
import AddReceiveChallanAgrMaster from './views/ReceiveChallanAgr/AddReceiveChallanAgrMaster.jsx';
import ReceiveChallanAgrMaster from './views/ReceiveChallanAgr/ReceiveChallanAgrMaster.jsx';
import AddChallanAgrMaster from './views/ChallanAgr/AddChallanAgrMaster.jsx';
import ChallanAgrMaster from './views/ChallanAgr/ChallanAgrMaster.jsx';
import AddVoucher from './views/Voucher/AddVoucher.jsx';
import Voucher from './views/Voucher/Voucher.jsx';
import LeaveRequestList from './views/LeaveApproval/LeaveRequestList';
import AddEditLeaveRequest from './views/LeaveApproval/AddEditLeaveRequest';
import SalaryDefinitionList from './views/SalaryDefinition/SalaryDefinitionList';
import AddEditSalaryDefinition from './views/SalaryDefinition/AddEditSalaryDefinition';
import AIGenerator from './views/AIGenerator/AIGenerator';
import AINavigationSearch from './views/AIGenerator/AINavigationSearch';
import StudentVerification from './views/StudentList/StudentVerification.jsx';
import FeeVerification from './views/StudentList/FeeVerification.jsx';
const FullLayout = lazy(() => import('./layouts/FullLayout.js'));

/***** Pages ****/

const Starter = lazy(() => import('./views/Starter.js'));

const FeeHead = lazy(() => import('./views/FeeHeadMaster/FeeHead.jsx'));
const AddFeeHead = lazy(() => import('./views/FeeHeadMaster/AddFeeHead.jsx'));
const EditFeeHead = lazy(() => import('./views/FeeHeadMaster/EditFeeHead.jsx'));
const Circle = lazy(() => import('./views/CircleMaster/Circle.jsx'));
const AddCircleMaster = lazy(
  () => import('./views/CircleMaster/AddCircleMaster.jsx'),
);
const Admission = lazy(() => import('./views/AdmissionMaster/Admission.jsx'));
const Slab = lazy(() => import('./views/SlabMaster/Slab.jsx'));
const AddSlabMaster = lazy(
  () => import('./views/SlabMaster/AddSlabMaster.jsx'),
);
const Fee_Group_Master_Details = lazy(
  () => import('./views/Fee_Group_Master/Fee_Group_Master_Search_Screen.jsx'),
);
const Fee_Group_Master_Add = lazy(
  () => import('./views/Fee_Group_Master/Fee_Group_Master_Add_Edit_Screen.jsx'),
);

const Class_Master_Details = lazy(
  () => import('./views/Class_Master/Class_Master_Search_Screen.jsx'),
);
const Class_Master_Add = lazy(
  () => import('./views/Class_Master/Class_Master_Add_Edit_Screen.jsx'),
);

const TcIssue_Master_Details = lazy(
  () =>
    import('./views/TcIssueMasterDetail/Tc_Issue_Master_Detail_Search_Screen.jsx'),
);
const TcIssue_Master_Add = lazy(
  () =>
    import('./views/TcIssueMasterDetail/Tc_Issue_Master_Detail_Add_Edit_Screen.jsx'),
);
const Fee_Reciept_Master_Search = lazy(
  () => import('./views/FeeReciept/Fee_Reciept_Master_Search.jsx'),
);
const Fee_Reciept_Add = lazy(
  () => import('./views/FeeReciept/Fee_Reciept_Master_Add_Edit_Screen.jsx'),
);
const SubjectMaster_Details = lazy(
  () => import('./views/SubjectMaster/Subject_Master_Search.jsx'),
);
const SubjectMaster_Add = lazy(
  () => import('./views/SubjectMaster/Subject_Master_Add_Edit_Screen.jsx'),
);
const ClassDetailMaster_Details = lazy(
  () => import('./views/ClassDetailMaster/Class_Detail_Master_Search.jsx'),
);
const ClassDetailMaster_Add = lazy(
  () =>
    import('./views/ClassDetailMaster/Class_Detail_Master_Add_Edit_Screen.jsx'),
);
const ResultMaster_Details = lazy(
  () => import('./views/ResultMaster/Result_Master_New_Search.jsx'),
);
const ResultDetailMaster_Add = lazy(
  () => import('./views/ResultMaster/Result_Master_New_Add_Edit_Screen.jsx'),
);
const AdmisionReport = lazy(() => import('./views/Report/AdmisionReports.jsx'));
const System_Record_Details = lazy(
  () => import('./views/SystemRecord/SystemRecords.jsx'),
);
const System_Record_Add = lazy(
  () => import('./views/SystemRecord/AddSystemRecord.jsx'),
);
const Multipurpose_Details = lazy(
  () =>
    import('./views/MultiPurposeMaster/Multi_Purpose_Type_Master_Search.jsx'),
);
const Multipurpose_Add = lazy(
  () =>
    import('./views/MultiPurposeMaster/Multi_Purpose_Type_Master_Add_Edit_Screen.jsx'),
);
const Transport_Details = lazy(
  () => import('./views/TransportMaster/Transport.jsx'),
);
const Transport_Add = lazy(
  () => import('./views/TransportMaster/Transport_Add_Edit.jsx'),
);
const Party = lazy(() => import('./views/Party/Party.jsx'));
const AddParty = lazy(() => import('./views/Party/AddParty.jsx'));

const AddItem = lazy(() => import('./views/Item/AddItem.jsx'));
const Item = lazy(() => import('./views/Item/Item.jsx'));
//const EditItem = lazy(() => import('./views/Item/EditItem.jsx'));

// const PartyCategoryMaster = lazy(
//   () => import('./views/PartyCategory/PartyCategoryMaster.jsx'),
// );
// const PartyCategoryDeletePage = lazy(
//   () => import('./views/PartyCategory/PartyCategoryDeletePage.jsx'),
// );
// const AddPartyCategoryMaster = lazy(
//   () => import('./views/PartyCategory/AddPartyCategoryMaster.jsx'),
// );
// const Aggreement_Details = lazy(
//   () => import('./views/AggrementMaster/Aggrement.jsx'),
// );

const AddBlogMaster_Add_Edit = lazy(
  () => import('./views/BlogMaster/AddBlogMaster.jsx'),
);
const AddBlogMaster_Details = lazy(
  () => import('./views/BlogMaster/BlogMaster.jsx'),
);

const MiniSlider_Add_Edit = lazy(
  () => import('./views/MiniSliderMaster/AddMiniSliderMaster.jsx'),
);
const MiniSlider_Details = lazy(
  () => import('./views/MiniSliderMaster/MiniSliderMaster.jsx'),
);
const Slider_Add_Edit = lazy(
  () => import('./views/SliderMaster/AddSliderMaster.jsx'),
);
const Slider_Details = lazy(
  () => import('./views/SliderMaster/SliderMaster.jsx'),
);
const Client_Add_Edit = lazy(
  () => import('./views/ClientMaster/AddClientMaster.jsx'),
);
const Client_Details = lazy(
  () => import('./views/ClientMaster/ClientMaster.jsx'),
);
const Contact_Add_Edit = lazy(
  () => import('./views/ContactMaster/AddContactMaster.jsx'),
);
const Contact_Details = lazy(
  () => import('./views/ContactMaster/ContactMaster.jsx'),
);
const FaqMaster_Add_Edit = lazy(
  () => import('./views/FaqMaster/AddFaqMaster.jsx'),
);
const FaqMaster_Details = lazy(() => import('./views/FaqMaster/FaqMaster.jsx'));
const SystemRecord_Add_Edit = lazy(
  () => import('./views/SystemRecord/AddSystemRecord.jsx'),
);
const SystemRecord_Details = lazy(
  () => import('./views/SystemRecord/SystemRecords.jsx'),
);

const FormMaster_Add_Edit = lazy(
  () => import('./views/FormMaster/AddFormMaster.jsx'),
);
const FormMaster_Details = lazy(
  () => import('./views/FormMaster/FormMaster.jsx'),
);
//const Viewcontact = lazy(() => import('./views/ContactMaster/Viewcontact.jsx'));
const Circular_Add_Edit = lazy(
  () => import('./views/CircularMaster/Add_Edit_Screen.jsx'),
);
const Circular_Details = lazy(
  () => import('./views/CircularMaster/Circular_Search_Screen.jsx'),
);
const InWard_Add_Edit = lazy(
  () => import('./views/WardOutMaster/WardOut_Add_Edit.jsx'),
);
const WardOut_List = lazy(
  () => import('./views/WardOutMaster/WardOut_List.jsx'),
);
const InWard_Add_Edit_screen = lazy(
  () => import('./views/WardInMaster/WardIn_Add_Edit.jsx'),
);
const WardOut_List_screen = lazy(
  () => import('./views/WardInMaster/WardIn_List.jsx'),
);
const Transaction_Add_Edit_screen = lazy(
  () => import('./views/TransactionForAllFlag/Transaction_Add_Edit.jsx'),
);
const Transaction_List_screen = lazy(
  () => import('./views/TransactionForAllFlag/Transaction_List.jsx'),
);
const Transaction = lazy(
  () => import('./views/TransactionForAllFlag/Transaction.jsx'),
);
const Transac_Pay_Rec_Detail = lazy(
  () => import('./views/TransactionForAllFlag/Transac_Payment_reciept.jsx'),
);
const Transaction_Sales_Purchase = lazy(
  () => import('./views/TransactionForAllFlag/Transaction_Sales_Purchase.jsx'),
);

// const Login = lazy(() => import('./views/LoginForm/Login.jsx'));

const FeeReport = lazy(() => import('./views/Report/FeeReport.jsx'));
/*****Routes******/
const App = () => {
  const authData = useSelector((state) => state.authState);
  
    const sessionData = useSelector((state) => state.sessionState);
    const systemData = sessionData?.systemData || {};
  const navigate = useNavigate();

  //const [systemData, setSystemData] = useState({});
  // this fucntino used for get system records detail

  const GetSystemRecordsData = async () => {
    if (!authData.isAuth) return;
    try {
      const response = await apiService.get(
        `api/SystemRecord/GetSystemRecordsById?branchId=${sessionData.branch_id}`,
      );
      if (response.status === true) {
       // setSystemData(response.systemRecordsDataById);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error(error);
      toast.error('Something went wrong while fetching system data.');
    }
  };
  useEffect(() => {
    registerFCMToken();
  }, [authData.isAuth]);

  useEffect(() => {
    listenForMessages();
  }, []);

  let ThemeRoutes;
  authData.isAuth
    ? (ThemeRoutes = [
        { path: '/', exact: true, element: <Navigate to='/Login' /> },
        { path: '/Login', exact: true, element: <Login /> },

        {
          path: '/NotificationTest',
          exact: true,
          element: <NotificationTest />,
        },
        {
          path: '/SessionSelection',
          exact: true,
          element: <SessionSelection />,
        },

        // { path: '/LoginNew', exact: true, element: <LoginNew /> },

        {
          path: '/',
          element: <FullLayout />,
          children: [
            { path: '/', element: <Navigate to='/starter' /> },
            { path: '/starter', exact: true, element: <Starter /> },

            //  add user login  credentials
            { path: '/user', exact: true, element: <UserMaster /> },
            { path: '/adduser', exact: true, element: <AddUserMaster /> },

            {
              path: '/userProfile',
              exact: true,
              element: <UserProfileMaster />,
            },
            {
              path: '/adduserProfile',
              exact: true,
              element: <AddUserProfileMaster />,
            },

            { path: '/vendor', exact: true, element: <VenderMaster /> },
            { path: '/addvendor', exact: true, element: <AddVenderMaster /> },

            { path: '/branch', exact: true, element: <BranchMaster /> },
            { path: '/addbranch', exact: true, element: <AddBranchMaster /> },

            ,
            ,
            // { path: '/IDCardPDF', exact: true, element: <IDCardPDF/> },

            // { path: "/addsale", exact: true, element: <AddSale /> },
            // { path: "/saledetail", exact: true, element: <SaleDetail/> },
            // { path: "/editsale", exact: true, element: <EditSale/> },
            {
              path: '/course-content',
              exact: true,
              element: <CourseContentPage />,
            },
            {
              path: '/attendance-master',
              exact: true,
              element: <AttendanceMasterPage />,
            },
            {
              path: '/attendance-student-list',
              exact: true,
              element: <AttendanceStudentListPage />,
            },

            //lead
            { path: '/new-lead', element: <AddLead /> },
            { path: '/all-leads', element: <GetLeadMaster /> },
            {
              path: '/lead-history/:leadId',
              element: <Leadhistory />,
            },

            /// -----FeeHead---------------------
            { path: '/FeeHead', exact: true, element: <FeeHead /> },
            { path: '/addFeeHead', exact: true, element: <AddFeeHead /> },
            { path: '/editFeeHead', exact: true, element: <EditFeeHead /> },
            { path: '/Circle', exact: true, element: <Circle /> },
            {
              path: '/addCircleMaster',
              exact: true,
              element: <AddCircleMaster />,
            }, //
            {
              path: '/PromoteAllStudents',
              exact: true,
              element: <PromoteAllStudents />,
            },
            {
              path: '/PromoteStudentsFeeSlabs',
              exact: true,
              element: <PromoteStudentsFeeSlabs />,
            },
            {
              path: '/CreateNewSessionSlab',
              exact: true,
              element: <CreateNewSessionSlab />,
            },
            {
              path: '/Admission',
              exact: true,
              element: <Admission systemData={systemData} />,
            },
            {
              path: '/AddAdmission',
              exact: true,
              element: <AddAdmissionNew systemData={systemData} />,
            },

            {
              path: '/StudentList',
              exact: true,
              element: <StudentList systemData={systemData} />,
            },
            {
              path: '/StudentAcSearch',
              exact: true,
              element: <StudentAcSearch systemData={systemData} />,
            },
            {
              path: '/StudentAc',
              exact: true,
              element: <StudentAc systemData={systemData} />,
            },

            { path: '/IcardBatches', exact: true, element: <ICardBatches /> },
            {
              path: '/SaveICardBatches',
              exact: true,
              element: <SaveICardBatches systemData={systemData} />,
            },

            ///SlabMaster
            { path: '/addSlabMaster', exact: true, element: <AddSlabMaster /> },
            {
              path: '/addSlabMasterOld',
              exact: true,
              element: <AddSlabMasterOld />,
            },

            { path: '/Slab', exact: true, element: <Slab /> },

            {
              path: '/Fee_Group_Master_Add_Edit_Screen',
              exact: true,
              element: <Fee_Group_Master_Add />,
            },
            {
              path: '/Fee_Group_Master_Search_Screen',
              exact: true,
              element: <Fee_Group_Master_Details />,
            },

            {
              path: '/save-course',
              exact: true,
              element: <Class_Master_Add />,
            },
            {
              path: '/course-list',
              exact: true,
              element: <Class_Master_Details />,
            },
            {
              path: '/TcIssueSaveScreen',
              exact: true,
              element: <TcIssueSaveScreen systemData={systemData} />,
            },
            {
              path: '/Tc_Issue_Master_Detail_Add_Edit_Screen',
              exact: true,
              element: <TcIssue_Master_Add />,
            },
            {
              path: '/Tc_Issue_Master_Detail_Search_Screen',
              exact: true,
              element: <TcIssue_Master_Details />,
            },
            {
              path: '/save-fee-reciept',
              exact: true,
              element: <Fee_Reciept_Add systemData={systemData} />,
            },
            {
              path: '/Fee_Reciept_Master_Search',
              exact: true,
              element: <Fee_Reciept_Master_Search systemData={systemData} />,
            },
            {
              path: '/fee-reciept-headwise-report',
              exact: true,
              element: <Fee_Reciept_HeadWise_Report systemData={systemData} />,
            },
            {
              path: '/Subject_Master_Add_Edit_Screen',
              exact: true,
              element: <SubjectMaster_Add />,
            },
            {
              path: '/Subject_Master_Search',
              exact: true,
              element: <SubjectMaster_Details />,
            },
            {
              path: '/Class_Detail_Master_Add_Edit_Screen',
              exact: true,
              element: <ClassDetailMaster_Add />,
            },
            {
              path: '/Class_Detail_Master_Search',
              exact: true,
              element: <ClassDetailMaster_Details />,
            },
            {
              path: '/Result_Master_New_Add_Edit_Screen',
              exact: true,
              element: <ResultDetailMaster_Add />,
            },
            {
              path: '/Result_Master_New_Search',
              exact: true,
              element: <ResultMaster_Details />,
            },
            {
              path: '/AdmisionReports',
              exact: true,
              element: <AdmisionReport />,
            },
            {
              path: '/FeeReport',
              exact: true,
              element: <FeeReport />,
            },
            {
              path: '/FeeDefaulterReport',
              exact: true,
              element: <FeeDefaulterReport systemData={systemData} />,
            },
            {
              path: '/AddSystemRecord',
              exact: true,
              element: <System_Record_Add />,
            },
            {
              path: '/SystemRecords',
              exact: true,
              element: <System_Record_Details />,
            },
            {
              path: '/save_multi_purpose_master',
              exact: true,
              element: <Multipurpose_Add />,
            },
            {
              path: '/multi_purpose_list',
              exact: true,
              element: <Multipurpose_Details />,
            },
            {
              path: '/Transport_Add_Edit',
              exact: true,
              element: <Transport_Add />,
            },
            {
              path: '/Transport',
              exact: true,
              element: <Transport_Details />,
            },

            { path: '/invoice', exact: true, element: <PDFGeneratorButton /> },
            {
              path: '/invoice_fm2',
              exact: true,
              element: <CreatePdf_Formate2 />,
            },
            {
              path: '/invoice_fm3',
              exact: true,
              element: <CreatePdf_Formate3 />,
            },
            {
              path: '/invoice_fm4',
              exact: true,
              element: <CreatePdf_Formate4 />,
            },
            {
              path: '/invoice_fm5',
              exact: true,
              element: <CreatePdf_Formate5 />,
            },
            {
              path: '/invoice_fm5_landscape',
              exact: true,
              element: <CreatePdf_Formate5_Landscape />,
            },

            {
              path: '/invoice_fm6',
              exact: true,
              element: <CreatePdf_Formate6 />,
            },

            {
              path: '/BlogMaster',
              exact: true,
              element: <AddBlogMaster_Details />,
            },
            {
              path: '/AddBlogMaster',
              exact: true,
              element: <AddBlogMaster_Add_Edit />,
            },
            {
              path: '/MiniSliderMaster',
              exact: true,
              element: <MiniSlider_Details />,
            },
            {
              path: '/AddMiniSliderMaster',
              exact: true,
              element: <MiniSlider_Add_Edit />,
            },
            {
              path: '/SliderMaster',
              exact: true,
              element: <Slider_Details />,
            },
            {
              path: '/AddSliderMaster',
              exact: true,
              element: <Slider_Add_Edit />,
            },
            {
              path: '/ContactMaster',
              exact: true,
              element: <Contact_Details />,
            },
            {
              path: '/AddContactMaster',
              exact: true,
              element: <Contact_Add_Edit />,
            },
            {
              path: '/FaqMaster',
              exact: true,
              element: <FaqMaster_Details />,
            },
            {
              path: '/AddFaqMaster',
              exact: true,
              element: <FaqMaster_Add_Edit />,
            },
            {
              path: '/ClientMaster',
              exact: true,
              element: <Client_Details />,
            },
            {
              path: '/AddClientMaster',
              exact: true,
              element: <Client_Add_Edit />,
            },
            {
              path: '/SystemRecords',
              exact: true,
              element: <SystemRecord_Details />,
            },
            {
              path: '/AddSystemRecord',
              exact: true,
              element: <SystemRecord_Add_Edit />,
            },
            {
              path: '/FormMaster',
              exact: true,
              element: <FormMaster_Details />,
            },
            {
              path: '/AddFormMaster',
              exact: true,
              element: <FormMaster_Add_Edit />,
            },
            // {
            //   path: '/Viewcontact',
            //   exact: true,
            //   element: <Viewcontact />,
            // },
            {
              path: '/Add_Edit_Screen',
              exact: true,
              element: <Circular_Add_Edit />,
            },
            {
              path: '/Circular',
              exact: true,
              element: <Circular_Details />,
            },

            {
              path: '/WardOut_List',
              exact: true,
              element: <WardOut_List />,
            },
            {
              path: '/WardOut_Add_Edit',
              exact: true,
              element: <InWard_Add_Edit />,
            },

            {
              path: '/WardIn_List',
              exact: true,
              element: <WardOut_List_screen />,
            },
            {
              path: '/WardIn_Add_Edit',
              exact: true,
              element: <InWard_Add_Edit_screen />,
            },
            {
              path: '/Transaction_List',
              exact: true,
              element: <Transaction_List_screen />,
            },
            {
              path: '/Transaction_Add_Edit',
              exact: true,
              element: <Transaction_Add_Edit_screen />,
            },

            {
              path: '/Transaction',
              exact: true,
              element: <Transaction />,
            },
            {
              path: '/Transac_Payment_reciept',
              exact: true,
              element: <Transac_Pay_Rec_Detail />,
            },
            {
              path: '/Transaction_Sales_Purchase',
              exact: true,
              element: <Transaction_Sales_Purchase />,
            },
            {
              path: '/save-faculty',
              exact: true,
              element: <AddFacultyMaster />,
            },
            {
              path: '/faculty-list',
              exact: true,
              element: <FacultyMaster />,
            },
            {
              path: '/enrollment-form',
              exact: true,
              element: <EnrollmentForm />,
            },
            {
              path: '/enrollment-list',
              exact: true,
              element: <EnrollmentList />,
            },
            {
              path: '/pending-enrollment-list',
              exact: true,
              element: <LeadsPendingForEnrollment />,
            },
            ,
            {
              path: '/save-batch',
              exact: true,
              element: <BatchMaster />,
            },
            {
              path: '/list-batch',
              exact: true,
              element: <GetBatchList />,
            },
            {
              path: '/batch-card-list-teaching-log',
              exact: true,
              element: (
                <BatchCardList
                  apiUrl='api/BatchMaster/GetBatches_FacultySubjectWise'
                  responseDataKey='facultyBatchSubjectsList'
                  actionButtonText='Log Today’s Teaching'
                  onActionClick={(batch) =>
                    navigate('/save-teaching', {
                      state: { batch: batch },
                    })
                  }
                />
              ),
            },

            {
              path: '/batch-card-list-attendence-log',
              exact: true,
              element: (
                <BatchCardList
                  apiUrl='api/BatchMaster/GetBatchListForAttendanceByFaculty'
                  responseDataKey='data'
                  actionButtonText='Log Today’s Attendance'
                  onActionClick={(batch) =>
                    navigate('/attendance-student-list', {
                      state: { batch: batch },
                    })
                  }
                />
              ),
            },

            {
              path: '/save-Weekend',
              exact: true,
              element: <SaveEditWeekend />,
            },
            {
              path: '/list-weekend',
              exact: true,
              element: <GetWeekendList />,
            },
            {
              path: '/save-holiday',
              exact: true,
              element: <SaveEditHoliday />,
            },
            {
              path: '/list-holiday',
              exact: true,
              element: <GetHolidayList />,
            },
            {
              path: '/attendence-Report',
              exact: true,
              element: <GetStudentAttendanceReport />,
            },
            {
              path: '/list-teaching',
              exact: true,
              element: <GetTeachingMaster />, //this is not
            },

            {
              path: '/save-teaching',
              exact: true,
              element: <AddTeachingMaster />,
            },
            {
              path: '/workflow-help',
              exact: true,
              element: <WorkflowHelpPage />,
            },

            {
              path: '/save-exam-term',
              exact: true,
              element: <SaveEditExamTerm />,
            },
            {
              path: '/list-exam-term',
              exact: true,
              element: <GetExamTermList />,
            },

            {
              path: '/save-course-exam-pattern',
              exact: true,
              element: <SaveEditCourseExamPattern />,
            },
            {
              path: '/list-course-exam-pattern',
              exact: true,
              element: <GetCourseExamPatternList />,
            },
            {
              path: '/save-cour-sub-exam-pattern',
              exact: true,
              element: <SaveCourseSubExamPattern />,
            },
            {
              path: '/list-cour-sub-exam-pattern',
              exact: true,
              element: <GetCourseSubExamPatternList />,
            },
            {
              path: '/save-catalog',
              exact: true,
              element: <SaveCreateSchoolCatalog />,
            },
            {
              path: '/list-catalog',
              exact: true,
              element: <GetCatalogList />,
            },

            {
              path: '/catalog-render',
              exact: true,
              element: <GetCatalogRenderer />,
            },
            {
              path: '/save-auto-assign',
              exact: true,
              element: <SaveAutoAssign />,
            },
            {
              path: '/list-auto-assign',
              exact: true,
              element: <GetAutoAssignList />,
            },
            {
              path: '/save-source-map',
              exact: true,
              element: <SaveSourceMapping />,
            },
            {
              path: '/list-source-map',
              exact: true,
              element: <GetSourceMappingList />,
            },

            {
              path: '/save-fine-master',
              exact: true,
              element: <SaveFineMaster />,
            },
            {
              path: '/list-fine-master',
              exact: true,
              element: <GetFineMasterList />,
            },

            {
              path: '/save-batch-exam',
              exact: true,
              element: <SaveBatchExamMaster />,
            },

            {
              path: '/list-batch-exam',
              exact: true,
              element: <GetBatchExamList />,
            },
            {
              path: '/save-session',
              exact: true,
              element: <SaveSessionMaster />,
            },

            {
              path: '/list-session',
              exact: true,
              element: <GetSessionList />,
            },
            {
              path: '/chatbot',
              exact: true,
              element: <GetChatBotPage />, //not done
            },
            {
              path: '/SaveExcelExportTblConfig',
              exact: true,
              element: <SaveExcelExportTblConfig />, //not done
            },

            {
              path: '/GetExcelExportTblConfig',
              exact: true,
              element: <GetExcelExportTblConfig />, //not done
            },
            {
              path: '/CommonImportExport',
              exact: true,
              element: <CommonImportExport />, //not done
            },
            {
              path: '/save-hostel',
              exact: true,
              element: <SaveHostelMaster />,
            },
            {
              path: '/list-hostel',
              exact: true,
              element: <GetHostelMaster />,
            },

            {
              path: '/save-hostel-mapping',
              exact: true,
              element: <StudentHostelAssign />,
            },
            {
              path: '/list-hostel-mapping',
              exact: true,
              element: <StudentHostelAssignList />,
            },
            {
              path: '/save-stud-result',
              exact: true,
              element: <SaveStudentExamResult />,
            },
            {
              path: '/student-exam-result-entry',
              exact: true,
              element: <SaveStudentExamResultEntry />, //not done
            },

            {
              path: '/list-stud-result',
              exact: true,
              element: <GetStudentExamResultList />,
            },
            // StudentPortal
            {
              path: '/student-portal/datesheet',
              exact: true,
              element: <ExamDateSheet />,
            },
            {
              path: '/student-portal/results',
              exact: true,
              element: <MyResults />,
            },
            {
              path: '/student-portal/content',
              exact: true,
              element: <CourseContent />,
            },
            {
              path: '/save-notification',
              exact: true,
              element: <SaveNotification />,
            },
            {
              path: '/list-notification',
              exact: true,
              element: <GetNotification />, //not done
            },
            //dashboard

            {
              path: '/faculty-dashboard',
              exact: true,
              element: <GetFacultydashboard />,
            },

            {
              path: '/student-dashboard',
              exact: true,
              element: <GetStudentdashboard />,
            },
            {
              path: '/accounts-dashboard',
              exact: true,
              element: <GetAccountantdashboard />,
            },
            {
              path: '/crm-dashboard',
              exact: true,
              element: <GetCrmdashboard />,
            },
            {
              path: '/save-class-routine',
              exact: true,
              element: <AddEditClassRoutine />,
            },
            {
              path: '/list-class-routine',
              exact: true,
              element: <ClassRoutineList />,
            },
            {
              path: '/list-time-table',
              exact: true,
              element: <GetTimeTableBoard />,
            },
            {
              path: '/list-faculty-time-table',
              exact: true,
              element: <GetFacultyTimeTableBoard />,
            },
            {
              path: '/list-student-payment',
              exact: true,
              element: <GetStudentPaymentList />,
            },
            {
              path: '/save-student-payment',
              exact: true,
              element: <SaveStudentPayment />,
            },
            {
              path: '/student-payment-view',
              exact: true,
              element: <ViewStudentPayment />,
            },
            {
              path: '/save-emp-attandance',
              exact: true,
              element: <SaveEmployeAttandance />,
            },
            {
              path: '/list-emp-attandance',
              exact: true,
              element: <GetEmployeAttandance />,
            },
            {
              path: '/employee-attendance-report',
              exact: true,
              element: <GetEmpAttenReportPage />,
            },
            //new
            { path: '/addparty', exact: true, element: <AddParty /> },
            { path: '/party', exact: true, element: <Party /> },
            { path: '/party/item', exact: true, element: <Party /> },
            // { path: "/deleteParty", exact: true, element: < PartyDeletePage /> },

            // { path: "/editparty", exact: true, element: <EditParty /> },

            {
              path: '/partyCategory',
              exact: true,
              element: <PartyCategoryMaster />,
            },
            {
              path: '/addpartyCategory',
              exact: true,
              element: <AddPartyPartyCategoryMaster />,
            },
            //{ path: "/deletePartyCategory", exact: true, element: < PartyCategoryDeletePage /> },

            { path: '/itemcategory', exact: true, element: <ItemCategory /> },
            {
              path: '/additemcategory',
              exact: true,
              element: <AddItemCategory />,
            },
            // { path: "/edititemcategory", exact: true, element: <EditItemCategory /> },

            { path: '/additem', exact: true, element: <AddItem /> },
            { path: '/item', exact: true, element: <Item /> },
            { path: '/city', exact: true, element: <CityMaster /> },
            { path: '/addcity', exact: true, element: <AddCityMaster /> },
            //cha
            { path: '/aggrement', exact: true, element: <Aggrement /> },
            // issue challan single
            {
              path: '/add_challan_issue',
              exact: true,
              element: (
                <AddChallanMaster
                  irFlag='IC'
                  irflag_detail='ISSUE_CHALLAN'
                  title='Issue Challan'
                />
              ),
            },
            {
              path: '/challan_issue',
              exact: true,
              element: (
                <ChallanMaster
                  irFlag='IC'
                  irflag_detail='ISSUE_CHALLAN'
                  title='Issue Challan'
                />
              ),
            },

            // issue challan aggrement
            {
              path: '/add_challan_issue_agr',
              exact: true,
              element: (
                <AddChallanAgrMaster
                  irFlag='IC_AGR'
                  irflag_detail='ISSUE_CHALLAN_AGRMENT'
                  title='Issue Ch. (FH)'
                />
              ),
            },
            {
              path: '/challan_issue_agr',
              exact: true,
              element: (
                <ChallanAgrMaster
                  irFlag='IC_AGR'
                  irflag_detail='ISSUE_CHALLAN_AGRMENT'
                  title='Issue Ch. (FH)'
                />
              ),
            },

            // issue receive single
            {
              path: '/challan_receive',
              exact: true,
              element: (
                <ReceiptedMaster
                  irFlag='RC'
                  nextIrFlag='IC'
                  irflag_detail='RECEIVE_CHALLAN'
                  nextIrflag_detail='ISSUE_CHALLAN'
                  title='Receive Challan'
                />
              ),
            },
            {
              path: '/add_challan_receive',
              exact: true,
              element: (
                <AddReceiptedMaster
                  irFlag='RC'
                  nextIrFlag='IC'
                  irflag_detail='RECEIVE_CHALLAN'
                  nextIrflag_detail='ISSUE_CHALLAN'
                  title='Receive Challan'
                />
              ),
            },

            // issue receive aggrement
            {
              path: '/challan_receive_agr',
              exact: true,
              element: (
                <ReceiveChallanAgrMaster
                  irFlag='RC_AGR'
                  irflag_detail='RECEIVE_CHALLAN_AGRMENT'
                  title='Receive Challan (Agreement)'
                />
              ),
            },
            {
              path: '/add_challan_receive_agr',
              exact: true,
              element: (
                <AddReceiveChallanAgrMaster
                  irFlag='RC_AGR'
                  irflag_detail='RECEIVE_CHALLAN_AGRMENT'
                  title='Receive Challan (Agreement)'
                />
              ),
            },

            // sale challan single
            {
              path: '/add_challan_sale',
              exact: true,
              element: (
                <AddChallanMaster
                  irFlag='SC'
                  irflag_detail='SALE_CHALLAN'
                  title='Sale Book'
                />
              ),
            },
            {
              path: '/challan_sale',
              exact: true,
              element: (
                <ChallanMaster
                  irFlag='SC'
                  irflag_detail='SALE_CHALLAN'
                  title='Sale Book'
                />
              ),
            },
            {
              path: '/systemRecords-option',
              exact: true,
              element: <SystemRecordsMaster />,
            },
            {
              path: '/systemRecords',
              exact: true,
              element: <AddSystemRecordsMaster />,
            },

            { path: '/helperMaster', exact: true, element: <HelperMaster /> },
            { path: '/addhelper', exact: true, element: <AddHelperMaster /> },

            {
              path: '/addhelperFlag',
              exact: true,
              element: <AddHelperFlagMaster />,
            },
            { path: '/helperFlag', exact: true, element: <HelperFlagMaster /> },
            { path: '/voucher', exact: true, element: <Voucher /> },
            { path: '/addvoucher', exact: true, element: <AddVoucher /> },

            {
              path: '/leave-request-list',
              exact: true,
              element: <LeaveRequestList />,
            },
            {
              path: '/save-leave-request',
              exact: true,
              element: <AddEditLeaveRequest />,
            },
            {
              path: '/list-salary-definition',
              exact: true,
              element: <SalaryDefinitionList />,
            },
            {
              path: '/save-salary-definition',
              exact: true,
              element: <AddEditSalaryDefinition />,
            },
            {
              path: '/ai-generator',
              exact: true,
              element: <AIGenerator />,
            },
            {
              path: '/ai-search',
              exact: true,
              element: <AINavigationSearch />,
            },
            { path: '/student-verification', exact: true, element: <StudentVerification /> },
            { path: '/fees-verification', exact: true, element: <FeeVerification /> },

          ],
        },
      ])
    : (ThemeRoutes = [
        {
          path: '/NotificationTest',
          exact: true,
          element: <NotificationTest />,
        },
        { path: '/', exact: true, element: <Navigate to='/Login' /> },
        { path: '/Login', exact: true, element: <Login /> },
        { path: '*', exact: true, element: <Navigate to='/Login' /> },
      ]);

  const routing = useRoutes(ThemeRoutes);

  return (
    <div className='dark'>
      <ToastNotifications />
      {routing}
    </div>
  );
};

export default App;
